import React from "react";

/**
 * Slim animated Xortec wave divider used as a decorative separator.
 * Two overlaid SVG wave paths drift horizontally at slightly different
 * speeds to feel alive without being distracting.
 */
export default function WaveDivider({ className = "", height = 36, opacity = 1 }) {
  return (
    <div
      className={`xortec-wave-divider ${className}`}
      style={{ height, opacity }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 1440 60"
        preserveAspectRatio="none"
        className="w-full h-full"
      >
        <defs>
          <linearGradient id="waveGrad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity="0" />
            <stop offset="20%" stopColor="hsl(var(--primary))" stopOpacity="0.6" />
            <stop offset="50%" stopColor="hsl(200 90% 62%)" stopOpacity="0.9" />
            <stop offset="80%" stopColor="hsl(var(--primary))" stopOpacity="0.6" />
            <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="waveGrad2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="hsl(200 90% 65%)" stopOpacity="0" />
            <stop offset="50%" stopColor="hsl(200 90% 65%)" stopOpacity="0.55" />
            <stop offset="100%" stopColor="hsl(200 90% 65%)" stopOpacity="0" />
          </linearGradient>
        </defs>
        <g className="wave-drift-a">
          <path
            d="M0,30 C240,10 480,50 720,30 C960,10 1200,50 1440,30 L1440,60 L0,60 Z"
            fill="url(#waveGrad)"
          />
        </g>
        <g className="wave-drift-b">
          <path
            d="M0,32 C200,50 400,10 640,32 C880,54 1120,10 1440,32 L1440,60 L0,60 Z"
            fill="url(#waveGrad2)"
          />
        </g>
      </svg>
    </div>
  );
}
